/**
 * Agent Module
 */
const getDefaultState = () => {
  return {
    preiviewLayout: false,
    templateList: [],
    templateId: '',
    templateTitle: '',
    templateContent: {
      templateType: 'NOTICE',
      content: {
        title: '',
        description: '',
        button: [],
        media: {
          type: '',
          url: '',
          autoPlay: false
        },
        btnColor: ''
      }
    }
  }
}
const state = getDefaultState()

const getters = {
  marketingTemplateId: (state) => {
    return state.templateId
  },
  marketingTemplateTitle: (state) => {
    return state.templateTitle
  },
  marketingTemplateContent: (state) => {
    return state.templateContent
  },
  marketingTemplateContentBtnColor: (state) => {
    return state.templateContent.content.btnColor
  },
  marketingTemplateContentTitle: (state) => {
    return state.templateContent.content.title
  },
  marketingTemplateContentDescription: (state) => {
    return state.templateContent.content.description
  },
  marketingTemplateContentMedia: (state) => {
    return state.templateContent.content.media
  },
  marketingTemplateList: (state) => {
    return state.templateList
  },
  marketingTemplateContentType: (state) => {
    return state.templateContent.templateType
  },
  marketingPreiviewLayout: (state) => {
    return state.preiviewLayout
  },
  marketingTemplateButton (state) {
    return state.templateContent.content.button
  }
}

const actions = {
}

const mutations = {
  resetMarketingTemplate (state) {
    Object.assign(state, getDefaultState())
  },
  setMarketingTemplateId (state, data) {
    state.templateId = data
  },
  setMarketingTemplateTitle (state, data) {
    state.templateTitle = data
  },
  setMarketingTemplateContent: (state, data) => {
    state.templateContent = data
  },
  setMarketingTemplateBtnColor: (state, data) => {
    state.templateContent.content.btnColor = data
  },
  setMarketingTemplateButton (state, data) {
    state.templateContent.content.button[0] = data
  },
  setMarketingTemplate (state, data) {
    state.templateContent.content.button.push(data)
  },
  addTitleTemplate (state, data) {
    state.templateContent.content.title = data
  },
  addDescriptionTemplate (state, data) {
    state.templateContent.content.description = data
  },
  addMediaTemplate (state, data) {
    state.templateContent.content.media = data
  },
  deleteButtonTemplate (state, index) {
    state.templateContent.content.button.splice(index, 1)
  },
  changeTemplateType (state, type) {
    state.templateContent.templateType = type
  },
  changeTemplateList (state, templateList) {
    state.templateList = templateList
  },
  selectTemplate (state, template) {
    state.templateId = template.marketingId
    state.templateTitle = template.marketingName
  },
  changeTemplateView (state, template) {
    state.templateContent = template.marketingTemplateContent
  },
  clearTemplateList (state) {
    state.templateList = []
  },
  clearTemplateContent (state) {
    state.templateContent.templateType = ''
    state.templateContent.content.title = ''
    state.templateContent.content.description = ''
    state.templateContent.content.media = {
      type: '',
      url: '',
      autoPlay: false
    }
    state.templateContent.content.button = []
  },
  addTemplate (state, template) {
    state.templateList.unshift(template)
  },
  deleteTemplate (state, template) {
    const templateIndex = state.templateList.map(template => template.marketingId).indexOf(template.marketingId)
    if (templateIndex === -1) {
      return
    }
    state.templateList.splice(templateIndex, 1)
    // if (state.templateList.length > 0) {
    //   this.selectTemplate(state.templateList[0])
    // } else {
    //   state.selectedScenario = undefined
    // }
  },
  setMarketingPreiviewLayout (state) {
    state.preiviewLayout = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/marketingPush/index.js